import React, { Component } from 'react';
import './style.css';
import logo from '../../logo_white.svg';
import { PageNotFound, Interview } from '../../components';
import { Route, Switch } from 'react-router-dom';
import DataApi from '../../DataApi';
import { URL_START } from '../../constants';
import Context from '../../context';

class App extends Component {
  state = {};

  fetchData() {
    fetch(
      process.env.REACT_APP_API_URL +
        '/backend/package/project/api/' +
        this.props.match.params.project +
        '/?format=json'
    )
      .then(res => res.json())
      .then(data => {
        const api = new DataApi(data);
        data = api.setupData();
        this.setState(data);
        sessionStorage.setItem('interview', JSON.stringify(data));
      });
  }

  componentWillMount() {
    const cached = sessionStorage.getItem('interview');
    if (cached) {
      this.setState(JSON.parse(cached));
    } else {
      this.fetchData();
    }
  }

  render() {
    if (this.state.objectPairs) {
      return (
        <div className="App card">
          <div class="card-header">
            <img className="logo" src={logo} alt="logo" />
          </div>
          <Switch>
            <Route
              path={URL_START + '/:project/'}
              render={({ match }) => (
                <Context.Provider
                  value={{
                    url: URL_START + '/' + this.props.match.params.project + '/'
                  }}
                >
                  <Interview {...this.state} />
                </Context.Provider>
              )}
            />
            <Route path="*" component={PageNotFound} />
          </Switch>
        </div>
      );
    }
    return null;
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/preference/containers/App/index.js